module.exports = __webpack_public_path__ + "static/media/speaker1.da34dc54.jpg";